import React, { useReducer } from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer';

const AddressState = (props) => {
  const initialState = {
    userAddress: {
      token: localStorage.getItem('token'),
      isAuthenticated: null,
      user: null,
      error: null,
    },
  };
  const [state] = useReducer(AuthReducer, initialState);

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        error: state.error,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AddressState;
